exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table .numerico{min-width:65px;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cfdaa3b8","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/consultas/consulta-resumo-movimento-estoque.vue
// module id = 2128
// module chunks = 0